// extracted by mini-css-extract-plugin
export var section = "rating-module--section--19ULJ";
export var head = "rating-module--head--1QqhB";
export var container = "rating-module--container--1kQnU";
export var ratingTitle = "rating-module--ratingTitle--1IV6D";
export var ratingTitle_text = "rating-module--ratingTitle_text--DK5Ak";
export var ratingList = "rating-module--ratingList--78zgp";
export var memoji = "rating-module--memoji--1vM9r";
export var btn = "rating-module--btn--InE0N";
export var iframe = "rating-module--iframe--3Gg1C";